export const gl = {
  'ad.label': 'Publicidade',
  'ad.sponsored_by': 'Patrocinado por {advertiser}',
  'ad.visit': 'Visitar',
  'cookies.preferences': 'Preferencias de cookies',
  'cookies.title': 'A túa privacidade, baixo o teu control',
  'cookies.description': 'Usamos almacenamento necesario para que Albambam funcione. Só activaremos analítica ou márketing se nos dás permiso. Podes retiralo en calquera momento. Consulta a',
  'cookies.privacy_link': 'Política de Privacidade',
  'cookies.close': 'Pechar preferencias',
  'cookies.necessary': 'Necesarias',
  'cookies.necessary_desc': 'Sesión, seguranza, idioma e preferencias básicas.',
  'cookies.analytics': 'Analítica',
  'cookies.analytics_desc': 'Medición anónima do uso para mellorar o servizo.',
  'cookies.marketing': 'Márketing',
  'cookies.marketing_desc': 'Personalización publicitaria e medición de campañas.',
  'cookies.configure': 'Configurar',
  'cookies.reject': 'Rexeitar opcionais',
  'cookies.save': 'Gardar selección',
  'cookies.accept': 'Aceptar todas',
  'lang.selector_label': 'Idioma',
  'lang.changed': 'Idioma cambiado',
  'nav.home': 'Inicio',
  'nav.categories': 'Categorías',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Amizade',
  'nav.upload': 'Subir',
  'nav.profile': 'Perfil',
  'nav.login': 'Entrar',
  'common.signed_in': 'Sesión iniciada',
  'common.error': 'Erro',
  'topbar.search_placeholder': 'Buscar vídeos, creadores...',
  'legal.terms': 'Termos',
  'legal.privacy': 'Privacidade',
  'nav.admin': 'Administración',
  'nav.logout': 'Pechar sesión',
  'admin.tab.payments': 'Cobros',
  'admin.payments.title': 'Cobros',
  'cats.title': 'Categorías',
  'cats.all': 'Todas',
  'cats.adult_title': 'Categorías +18',
  'cats.empty': 'Non hai vídeos nesta categoría.',
  'friends.block_confirm': 'Bloquear este amigo? Xa non poderedes chatear nin veros como amigos.',
  'friends.accepted': 'Agora sodes amigos!',
  'friends.title': 'Amizade',
  'friends.subtitle': 'Só quen se segue mutuamente se fai amigo e pode chatear en privado.',
  'friends.unread_count_label': '{n} mensaxes por ler',
  'friends.blocked_users_title': 'Usuarios bloqueados',
  'friends.unblock_user': 'Desbloquear',
  'friends.requests_title': 'Solicitudes de chat',
  'friends.request_badge': 'Solicitude',
  'friends.request_accept': 'Aceptar',
  'friends.request_ignore': 'Ignorar',
  'friends.empty_title': 'Aínda non tes amigos',
  'friends.empty_subtitle': 'Segue a alguén e que te siga de volta para desbloquear o chat privado.',
  'friends.attach_image': 'Foto',
  'friends.shared_video_label': 'Compartiu un vídeo',
  'friends.select_conversation': 'Selecciona un amigo para comezar a chatear',
  'friends.block_user': 'Bloquear',
  'friends.no_messages_yet': 'Aínda non hai mensaxes. Sauda!',
  'friends.message_placeholder': 'Escribe unha mensaxe...',
  'section.trending': 'Tendencias',
  'section.shorts': 'Shorts',
  'section.for_you': 'Para ti',
  'home.hero.badge': 'Benvidos a Albambam',
  'home.hero.title_1': 'Vídeos curtos.',
  'home.hero.title_2': 'Creadores reais.',
  'home.hero.subtitle': 'Mira, comparte e gaña. Sube os teus vídeos e descobre novos talentos en cada categoría.',
  'home.hero.cta_shorts': 'Ver Shorts',
  'home.hero.cta_trending': 'Tendencias',
  'home.shorts.see_all': 'Ver todos',
  'home.empty.title': 'Aínda non hai vídeos',
  'home.empty.subtitle': 'Cando os creadores suban contido, aparecerá aquí.',
  'live.send_diamonds': 'Enviar diamantes',
  'live.buy': 'Comprar',
  'live.chat': 'Chat',
  'live.type_message': 'Escribe unha mensaxe...',
  'live.send': 'Enviar',
  'auth.success_google': 'Sesión iniciada con Google',
  'auth.fail_google': 'Sesión de Google non válida',
  'auth.success_login': 'Sesión iniciada',
  'auth.success_register': 'Conta creada',
  'auth.login_tab': 'Entrar',
  'auth.register_tab': 'Crear conta',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contrasinal',
  'auth.submit_login_loading': 'Entrando...',
  'auth.submit_login': 'Entrar',
  'auth.name': 'Nome',
  'auth.submit_register_loading': 'Creando...',
  'auth.submit_register': 'Crear conta',
  'auth.or': 'ou',
  'legal.privacy_title': 'Política de Privacidade',
  'search.title': 'Resultados para "{q}"',
  'search.count': '{n} vídeos',
  'search.empty': 'Sen resultados.',
  'series.load_error': 'Non se puido cargar a serie',
  'series.unlocked': 'Serie desbloqueada',
  'series.purchase_error': 'Non se puido iniciar a compra',
  'series.restricted': 'Acceso restrinxido',
  'series.configure_access': 'Configurar acceso',
  'series.language_all': 'Todos os idiomas',
  'series.episode_count': '{n} episodios',
  'series.buy': 'Comprar serie',
  'series.filter_language': 'Filtrar por idioma',
  'series.no_episodes': 'Aínda non hai episodios publicados.',
  'series.episode_number': 'Episodio {n}',
  'legal.terms_title': 'Termos e Condicións',
  'lang.ca': 'Catalán',
  'lang.en': 'Inglés',
  'lang.es': 'Castelán',
  'lang.fr': 'Francés',
  'lang.de': 'Alemán',
  'lang.it': 'Italiano',
  'lang.eu': 'Éuscaro',
  'lang.gl': 'Galego',
  'lang.zh': 'Chinés',
  'lang.other': 'Outros',
  'lang.vi': 'Vietnamita',
  'lang.ja': 'Xaponés',
  'lang.ko': 'Coreano',
  'lang.ru': 'Ruso',
  'lang.ro': 'Rumano',
  'lang.ar': 'Árabe',
  'lang.tr': 'Turco',
  'lang.pl': 'Polaco',
  'lang.ms': 'Malaio',
  'lang.ta': 'Tamil',
  'upload.series_title_error': 'Escribe o título da serie',
  'upload.series_adult_category_error': 'Selecciona unha categoría +18 para a serie',
  'upload.series_created': 'Serie creada',
  'upload.series_create_error': 'Non se puido crear a serie',
  'upload.err_file': 'Selecciona un ficheiro de vídeo válido',
  'upload.err_title': 'Pon un título',
  'upload.series_select_error': 'Selecciona ou crea unha serie',
  'upload.trailer_target_error': 'Selecciona o vídeo ou serie do tráiler',
  'upload.price_error': 'Introduce un prezo válido de como mínimo 0,50 EUR.',
  'upload.adult_category_error': 'Selecciona unha categoría adulta',
  'upload.success': 'Vídeo subido correctamente',
  'upload.title_h': 'Sube un vídeo',
  'upload.kind': 'Tipo de publicación',
  'upload.kind_video': 'Vídeo independente',
  'upload.kind_episode': 'Episodio dunha serie',
  'upload.kind_trailer': 'Tráiler público en Shorts',
  'upload.series': 'Serie',
  'upload.series_select': 'Selecciona unha serie',
  'upload.episode': 'Episodio',
  'upload.series_new_title': 'Título dunha serie nova',
  'upload.series_create': 'Crear serie',
  'upload.series_adult': 'Serie +18',
  'upload.series_premium': 'Serie premium',
  'upload.series_adult_category': 'Categoría +18 da serie',
  'upload.series_price': 'Prezo por episodio e paquete (EUR)',
  'upload.trailer_for': 'O tráiler presenta',
  'upload.trailer_select': 'Selecciona vídeo ou serie',
  'upload.video_prefix': 'Vídeo',
  'upload.file_label': 'Ficheiro de vídeo (MP4, máx 1GB)',
  'upload.file_pick': 'Fai clic para seleccionar un vídeo',
  'upload.thumb_label': 'Miniatura (opcional)',
  'upload.video_title': 'Título',
  'upload.description': 'Descrición',
  'upload.category': 'Categoría',
  'upload.is_short': 'É un Short (vertical)',
  'upload.paid_video': 'Vídeo de pago',
  'upload.adult_content': 'Contido +18',
  'upload.video_language': 'Idioma do vídeo',
  'upload.individual_price': 'Prezo por ver este vídeo (EUR)',
  'upload.paid_video_help': 'O espectador comprará acceso permanente só a este vídeo. O prezo mínimo é 0,50 EUR.',
  'upload.adult_category': 'Categoría adulta',
  'upload.uploading': 'Subindo {n}%',
  'upload.submit': 'Subir vídeo',
  'user.followers': 'seguidores',
  'user.following': 'seguidos',
  'user.follow': 'Seguir',
  'user.chat_open': 'Chatear',
  'user.request_sent': 'Solicitude enviada',
  'user.send_message': 'Enviar mensaxe',
  'user.followers_title': 'Seguidores',
  'user.following_title': 'Seguidos',
  'user.unfollow': 'Deixar de seguir',
  'user.request_title': 'Solicitude de chat',
  'user.request_subtitle': 'Só podes enviar unha mensaxe. Se acepta a solicitude, seredes amigos e poderedes chatear.',
  'user.request_placeholder': 'Escribe a túa mensaxe...',
  'user.request_send': 'Enviar solicitude',
  'shorts.login_for_like': 'Inicia sesión para dar Gústame',
  'watch.share_copied': 'Ligazón copiada',
  'watch.delete_confirm': 'Eliminar este comentario?',
  'ad.skip_in': 'Saltar en {n}s',
  'ad.skip': 'Saltar anuncio',
  'watch.share': 'Compartir',
  'friends.share_video': 'Comparte un vídeo',
  'friends.send': 'Enviar',
  'watch.comments': 'Comentarios',
  'watch.write_comment': 'Escribe un comentario...',
  'watch.publish': 'Publicar',
  'watch.login_to_comment': 'Hai que iniciar sesión para comentar.',
  'watch.login_btn': 'Entra para comentar',
  'watch.no_comments': 'Aínda non hai comentarios.',
  'watch.related': 'Relacionados',
  'nav.trending': 'Tendencias',
  'friends.follow_option_only_follow': 'Seguir',
  'friends.follow_option_friends': 'Amigos',
  'watch.like': 'Gústame',
  'watch.views_short': '{n} visualizacións',
  'shorts.empty.title': 'Aínda non hai Shorts',
  'shorts.empty.subtitle': 'Sube un vídeo curto para estrear a sección.',
  'shorts.share': 'Compartir',
  'auth.continue_google': 'Continuar con Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Prezo (€)',
  'upload.err_select': 'Selecciona un vídeo',
  'profile.upload_btn': 'Subir vídeo',
  'profile.tab_videos': 'Os meus vídeos ({n})',
  'profile.tab_history': 'Historial',
  'profile.tab_recos': 'Recomendacións',
  'profile.no_videos': 'Aínda non subiches ningún vídeo.',
  'profile.no_history': 'Aínda non viches ningún vídeo.',
  'profile.no_recos': 'Mira algúns vídeos para recibir recomendacións.',
  'profile.likes': 'gústames',
  'profile.views': 'visualizacións',
  'wallet.title': 'Carteira',
  'wallet.rate_label': 'Taxa',
  'wallet.min_label': 'Mínimo de retirada',
  'wallet.amount_label': 'Cantidade a retirar',
  'wallet.withdraw_btn': 'Solicitar retirada',
  'wallet.history_title': 'Histórico de solicitudes',
  'wallet.success': 'Solicitude creada',
  'wallet.bad_amount': 'Cantidade non válida',
  'wallet.per_view': '{rate} {cur}/visualización',
  'admin.title': 'Administración',
  'admin.stats.users': 'Usuarios',
  'admin.stats.videos': 'Vídeos',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Visualizacións',
  'admin.tab.videos': 'Vídeos',
  'admin.tab.ads': 'Anuncios',
  'admin.tab.users': 'Usuarios',
  'admin.tab.withdrawals': 'Retiradas',
  'admin.tab.config': 'Configuración',
  'admin.tab.translations': 'Idiomas',
  'tbl.title': 'Título',
  'tbl.creator': 'Creador',
  'tbl.category': 'Categoría',
  'tbl.type': 'Tipo',
  'tbl.views': 'Views',
  'tbl.likes': 'Likes',
  'tbl.status': 'Estado',
  'tbl.actions': 'Accións',
  'tbl.placement': 'Posición',
  'tbl.advertiser': 'Anunciante',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clicks',
  'tbl.active': 'Activo',
  'tbl.name': 'Nome',
  'tbl.email': 'Correo',
  'tbl.role': 'Rol',
  'tbl.wallet': 'Carteira',
  'tbl.amount': 'Cantidade',
  'tbl.date': 'Data',
  'tbl.user': 'Usuario',
  'video.video': 'Vídeo',
  'video.short': 'Short',
  'action.show': 'Publicar',
  'action.hide': 'Ocultar',
  'action.delete_confirm_video': 'Eliminar vídeo?',
  'ad.create_h': 'Crear anuncio',
  'ad.title_label': 'Título',
  'ad.image_label': 'URL imaxe',
  'ad.target_label': 'URL destino',
  'ad.advertiser_label': 'Anunciante',
  'ad.placement_label': 'Posicionamento',
  'ad.placement.banner': 'Banner (sitio web)',
  'ad.placement.preroll': 'Pre-roll (antes do vídeo)',
  'ad.placement.overlay': 'Overlay (dentro do vídeo)',
  'ad.active': 'Activo',
  'ad.create_btn': 'Crear',
  'ad.success_create': 'Anuncio creado',
  'ad.delete_confirm': 'Eliminar anuncio?',
  'users.make_admin': 'Facer admin',
  'users.remove_admin': 'Quitar admin',
  'wd.approve': 'Aprobar',
  'wd.reject': 'Rexeitar',
  'wd.mark_paid': 'Marcar pagado',
  'wd.empty': 'Sen solicitudes',
  'cfg.title': 'Configuración de pagos',
  'cfg.rate_label': 'Pago por visualización ({cur})',
  'cfg.min_label': 'Mínimo para retirar ({cur})',
  'cfg.currency': 'Moeda',
  'cfg.save': 'Gardar',
  'cfg.saved': 'Configuración gardada',
  'trans.title': 'Idiomas e traducións',
  'trans.intro': 'Sube un ficheiro JSON con traducións para calquera código de idioma (p.ex. ja, pt, zh). O ficheiro debe conter un mapeo plano de clave → texto.',
  'trans.code_label': 'Código de idioma (p.ex. ja, pt-BR, zh)',
  'trans.name_label': 'Nome (nese idioma)',
  'trans.file_label': 'Ficheiro JSON de traducións',
  'trans.upload': 'Subir',
  'trans.uploaded': 'Traducións gardadas',
  'trans.delete': 'Eliminar',
  'trans.delete_confirm': 'Eliminar este idioma?',
  'trans.builtin': 'Integrado',
  'trans.custom': 'Personalizado',
  'trans.empty_custom': 'Aínda non hai idiomas personalizados.',
  'common.cancel': 'Cancelar',
  'common.loading': 'Cargando...',
  'common.too_fast': 'Moi rápido, agarda un momento',
  'time.few_seconds': 'hai uns segundos',
  'time.min': 'hai {n} min',
  'time.h': 'hai {n} h',
  'time.d': 'hai {n} d',
  'time.w': 'hai {n} sem',
  'time.mo': 'hai {n} mes',
  'time.y': 'hai {n} ano',
  'brand.tagline': 'Vídeos curtos. Creadores reais.',
  'live.section': 'En directo',
  'live.start': 'Comeza un directo',
  'live.end': 'Remata o directo',
  'live.join': 'Entra en directo',
  'live.chat_placeholder': 'Escribe unha mensaxe...',
  'live.diamond': 'Diamante',
  'live.buy_access': 'Compra acceso',
  'live.save_recording': 'Gardar gravación',
};
